import { render, staticRenderFns } from "./SAMLLogin.vue?vue&type=template&id=16904f5c"
import script from "./SAMLLogin.vue?vue&type=script&lang=ts"
export * from "./SAMLLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports